'use strict';

function PartnerAttribution() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  this.init = function () {};

  this.initAllReady = function () {};

  this.saveAttributionData = function (key) {
    var _param = getURLParameter(key).trim();
    if (_param) {
      Cookies.set(key, _param, { expires: 9999 });
      Cookies.set('last_partner_attribution', key, { expires: 9999 });
    }
  };

  this.setPartnerAttribution = function () {
    // TODO: (maybe) generic foreach of settings obj instead
    var _last_partner_attribution = Cookies.getJSON('last_partner_attribution');
    var _moneywiseCode = Cookies.getJSON(PartnerAttributionSettings.moneywise.attribution_key);
    var _fintelConnectCode = Cookies.getJSON(PartnerAttributionSettings.fintel_connect.attribution_key);

    // add moneywise to form if cookie exists:
    if (_moneywiseCode && _last_partner_attribution === PartnerAttributionSettings.moneywise.attribution_key) {
      this._addHiddenFormFields(_moneywiseCode, PartnerAttributionSettings.moneywise.attribution_partner_id);
    }

    // add fintel_connect to form if cookie exists:
    if (_fintelConnectCode && _last_partner_attribution === PartnerAttributionSettings.fintel_connect.attribution_key) {
      this._addHiddenFormFields(_fintelConnectCode, PartnerAttributionSettings.fintel_connect.attribution_partner_id);
    }
  };

  this._addHiddenFormFields = function (attributionCode, attributionPartnerId) {
    var codeInput = document.createElement('input');
    codeInput.type = 'hidden';
    codeInput.name = 'attribution_code';
    codeInput.value = attributionCode;
    this._form.appendChild(codeInput);

    var partnerInput = document.createElement('input');
    partnerInput.type = 'hidden';
    partnerInput.name = 'attribution_partner_id';
    partnerInput.value = attributionPartnerId;
    this._form.appendChild(partnerInput);
  };
}

// Partner Attribution tracking
// key used for params and cookies
// partner_id & attribution_code passed to SOA
var PartnerAttributionSettings = {
  moneywise: {
    attribution_partner_id: 1,
    attribution_key: 'ribn_transaction_id'
  },
  fintel_connect: {
    attribution_partner_id: 2,
    attribution_key: 'finteltag'
  }
};